// src/redux/reducers/menuManageReducer.js

import { combineReducers } from "redux";

import giftCardSlice from "../slice/loyalty/gift-slice";
import giftCardHistorySlice from "../slice/loyalty/gift-history-slice";
import voucherSlice from "../slice/loyalty/voucher-slice";
import voucherHistorySlice from "../slice/loyalty/voucherHistorySlice";
import C2CVoucherSlice from "../slice/loyalty/C2CVoucherSlice";
import ConcessionSlice from "../slice/loyalty/ConcessionSlice";
import PointBasedOfferSlice from "../slice/loyalty/PointBasedOfferSlice";
import PointBasedOfferHistorySlice from "../slice/loyalty/PointBasedOfferHistorySlice";
import LoyaltySlice from "../slice/loyalty/templeteSlice";
import buyGetItemOfferSlice from "../slice/loyalty/buyGetItemOfferSlice";
import buyGetDiscountOfferSlice from "../slice/loyalty/buyGetDiscountOfferSlice";
import spendGetItemOfferSlice from "../slice/loyalty/spendGetItemOfferSlice";
import spendGetDiscountOfferSlice from "../slice/loyalty/spendGetDiscountOfferSlice";
import onlineOrderDiscountOfferSlice from "../slice/loyalty/onlineOrderDiscountOfferSlice";

const loyaltyReducer = combineReducers({
  giftCard: giftCardSlice,
  giftCardHistory: giftCardHistorySlice,
  voucher: voucherSlice,
  voucherHistory: voucherHistorySlice,
  C2CVoucher: C2CVoucherSlice,
  concession: ConcessionSlice,
  pointBasedOffer: PointBasedOfferSlice,
  pointBasedOfferHistory: PointBasedOfferHistorySlice,
  template: LoyaltySlice,
  buyGetItemOffer: buyGetItemOfferSlice,
  buyGetDiscountOffer: buyGetDiscountOfferSlice,
  spendGetItemOffer: spendGetItemOfferSlice,
  spendGetDiscountOffer: spendGetDiscountOfferSlice,
  onlineOrderDiscountOffer: onlineOrderDiscountOfferSlice,
});

export default loyaltyReducer;
